<div class="pcons-summary">
  <div *ngIf="selection?.length !== 1" class="arm-summary">{{ selection?.length || 0 }} Items selected</div>
  <div *ngIf="selection?.length === 1" class="arm-summary">
    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name">Name:</span>
      <span class="arm-summary-value" [matTooltip]="selection[0].name">{{ selection[0].name }}</span>
    </div>

    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name">Administrative State:</span>
      <span class="arm-summary-value"
            [matTooltip]="generateAdministrativeStateLabel()">{{ generateAdministrativeStateLabel() }}</span>
    </div>
    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name">Operative State:</span>
      <span class="arm-summary-value" [matTooltip]="selection[0].operState">{{ selection[0].operState }}</span>
    </div>
    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name">IPGroup Name:</span>
      <span class="arm-summary-value" [matTooltip]="selection[0].nativeName">{{ selection[0].nativeName }}</span>
    </div>
    <div fxLayout="row" class="arm-summary-item" *ngIf="selection[0].peerConnectionNodeType === 'Virtual'">
      <span class="arm-summary-name">TGRP:</span>
      <span class="arm-summary-value" [matTooltip]="selection[0].tgrp">{{ selection[0].tgrp }}</span>
    </div>

    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name">Weight:</span>
      <span class="arm-summary-value" [matTooltip]="selection[0].weight">{{ selection[0].weight }}</span>
    </div>
    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name">Node name:</span>
      <span class="arm-summary-value" [matTooltip]="selection[0].nodeName">{{ selection[0].nodeName }}</span>
    </div>
    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name">Peer connection type:</span>
      <span class="arm-summary-value"
            [matTooltip]="selection[0].peerConnectionNodeType">{{ selection[0].peerConnectionNodeType }}</span>
    </div>
    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name">Quality:</span>
      <span class="arm-summary-value" [matTooltip]="selection[0].result">{{ selection[0].result }}</span>
    </div>

    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name">MOS:</span>
      <span class="arm-summary-value"
            [title]="selection[0].quality.MOS.measurement == -1 ? 'UNKNOWN' : selection[0].quality.MOS.measurement">
                      {{ selection[0].quality.MOS.measurement == -1 ? 'UNKNOWN' : selection[0].quality.MOS.measurement }}
              </span>
    </div>

    <div fxLayout="row" class="arm-summary-item">
      <span class="arm-summary-name">ASR:</span>
      <span class="arm-summary-value"
            [title]="selection[0].quality.ASR.measurement == -1 ? 'UNKNOWN' : selection[0].quality.ASR.measurement">
                    {{ selection[0].quality.ASR.measurement == -1 ? 'UNKNOWN' : selection[0].quality.ASR.measurement }}
              </span>
    </div>

    <div *ngIf="selection[0].callsQuotaId">
      <div fxLayout="row" class="arm-summary-item">
        <span class="arm-summary-name">Calls quota:</span>
      </div>

      <div class="calls-quota">
        <div fxLayout="row" class="arm-summary-item">
          <span class="arm-summary-name">Quota name:</span>
          <span class="arm-summary-value"
                [title]="selection[0].callsQuotaName">{{ selection[0].callsQuotaName }}</span>
        </div>

        <div fxLayout="row" class="arm-summary-item">
          <span class="arm-summary-name">Calls duration (minutes):</span>
          <span class="arm-summary-value"
                [title]="selection[0].callsDuration || '0'">{{ selection[0].callsDuration || '0' }}</span>
        </div>

        <div fxLayout="row" class="arm-summary-item">
          <span class="arm-summary-name">Outgoing calls:</span>
          <span class="arm-summary-value">
            <i class="fa fa-check summary-value-green" *ngIf="selection[0].quotaState === 'UNBLOCK'"></i>
            <i class="fa fa-times summary-value-red" *ngIf="selection[0].quotaState === 'BLOCK_OUTGOING'"></i>
          </span>
        </div>

        <div fxLayout="row" class="arm-summary-item">
          <span class="arm-summary-name">Warning threshold reached:</span>
          <span class="arm-summary-value">
            <span class="summary-value-red" *ngIf="selection[0].quotaWarningReached">Yes</span>
            <span class="summary-value-green" *ngIf="!selection[0].quotaWarningReached">No</span>
          </span>
        </div>

        <div fxLayout="row" class="arm-summary-item">
          <span class="arm-summary-name">Quota reached:</span>
          <span class="arm-summary-value">
            <span class="summary-value-red" *ngIf="selection[0].quotaLimitReached">Yes</span>
            <span class="summary-value-green" *ngIf="!selection[0].quotaLimitReached">No</span>
          </span>
        </div>
      </div>
    </div>

    <div *ngIf="selection[0].cacProfileId">
      <div fxLayout="row" class="arm-summary-item">
        <span class="arm-summary-name">CAC Profile:</span>
        <span class="arm-summary-value"
              [title]="selection[0].cacProfileName">{{ selection[0].cacProfileName }}</span>
      </div>
      <div fxLayout="row" class="arm-summary-item">
        <span class="arm-summary-name">CAC State:</span>
        <span class="arm-summary-value" [title]="selection[0].cacState">{{ selection[0].cacState }}</span>
      </div>
    </div>

    <div *ngIf="selection[0].shortCallsProfileId">
      <div fxLayout="row" class="arm-summary-item">
        <span class="arm-summary-name">Short Calls:</span>
      </div>
      <div class="short-calls">

        <div fxLayout="row" class="arm-summary-item">
          <span class="arm-summary-name">Profile Name:</span>
          <span class="arm-summary-value"
                [title]="selection[0].shortCallsProfileName">{{ selection[0].shortCallsProfileName }}</span>
        </div>

        <div fxLayout="row" class="arm-summary-item">
          <span class="arm-summary-name">Min. calls per day:</span>
          <span class="arm-summary-value"
                [title]="selection[0].shortCallsMinDailyTotalCalls">{{ selection[0].shortCallsMinDailyTotalCalls }}</span>

        </div>

        <div fxLayout="row" class="arm-summary-item">
          <span class="arm-summary-name">Current daily calls:</span>
          <span class="arm-summary-value"
                [title]="selection[0].shortCallsCurrentTotalCalls">{{ selection[0].shortCallsCurrentTotalCalls }}
            ({{ (selection[0].shortCallsMinDailyTotalCalls - selection[0].shortCallsCurrentTotalCalls) < 0 ? 'Calls limit exceeded' : (selection[0].shortCallsMinDailyTotalCalls - selection[0].shortCallsCurrentTotalCalls + ' left') }})

        </span>
        </div>


        <div fxLayout="row" class="arm-summary-item">
          <span class="arm-summary-name">Current Short Call percentage:</span>
          <span class="arm-summary-value" [title]="selection[0].shortCallsPercentage">{{selection[0].shortCallsPercentage}}%</span>
        </div>
        <div fxLayout="row" class="arm-summary-item">

          <span class="arm-summary-name">Thresholds reached:</span>
          <span class="arm-summary-value">
            <span class="arm-summary-value-red" *ngIf="selection[0].shortCallsLimitReached">Yes</span>
            <span class="arm-summary-value-green" *ngIf="!selection[0].shortCallsLimitReached">No</span>
        </span>
        </div>
        <div fxLayout="row" class="arm-summary-item" *ngIf="selection[0].shortCallsLimitReached">
          <span class="arm-summary-name">Action:</span>
          <span class="arm-summary-value" [ngSwitch]="selection[0].shortCallsState">
          <span *ngSwitchCase="'LOCKED_FOR_OUTGOING'">Lock peer connection for new outgoing calls</span>
          <span *ngSwitchCase="'DROP_OUTGOING'">Drop new outgoing calls</span>
          <span *ngSwitchCase="'UNBLOCK'">Alarm only</span>
          <span *ngSwitchDefault>Unknown</span>
       </span>
        </div>


      </div>

    </div>


  </div>
</div>
